export const Mark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="mp-gold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#EED69A" />
        <stop offset="0.5" stopColor="#C9A04A" />
        <stop offset="1" stopColor="#9A6E22" />
      </linearGradient>
    </defs>
    <circle cx="32" cy="32" r="29" fill="none" stroke="url(#mp-gold)" strokeWidth="1.2" />
    <path d="M30 9a23 23 0 1 0 19 36A19 19 0 1 1 30 9z" fill="url(#mp-gold)" />
    <circle cx="41" cy="24" r="4.2" fill="url(#mp-gold)" />
    <g stroke="url(#mp-gold)" strokeWidth="1.3" strokeLinecap="round">
      <path d="M41 15.5v3" />
      <path d="M47.5 18l-2 2" />
      <path d="M50 24h-3" />
      <path d="M34.5 18l2 2" />
    </g>
    <path d="M46 42l1 2.4 2.4 1-2.4 1-1 2.4-1-2.4-2.4-1 2.4-1z" fill="url(#mp-gold)" />
  </svg>
);
